import React, { Suspense } from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import viewsRoutes from './views/routes';

const Routes = (): JSX.Element => {
  return (
    <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
      <ReactRoutes>
         {viewsRoutes.map((item, i) => (
          <Route key={i} path={item.path} element={item.renderer()} />
          ))}
        <Route path="/" element={<Navigate replace to="/home1" />} />
        <Route path="*" element={<Navigate replace to="/home1" />} />
      </ReactRoutes>
    </Suspense>
  );
};

export default Routes;
